import React from 'react';

const LoadingSpinner = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 100 100">
      {/* Centered Image */}
      <image
        href="https://jbarchitectseng.com/favicon-96x96.png"
        x="25"
        y="25"
        height="50"
        width="50"
      />
      {/* Spinning Circle */}
      <circle
        className="spinner-circle"
        cx="50"
        cy="50"
        r="40"
        stroke="#e7b037"
        strokeWidth="5"
        fill="none"
        strokeDasharray="100"
        strokeDashoffset="100"
      />
      <style>{`
        .spinner-circle {
          animation: spin 1s linear infinite;
          transform-origin: 50% 50%;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </svg>
  );
};

export default LoadingSpinner;
